// extracted by mini-css-extract-plugin
export default {"input":"InputPassword_input__9Cd5p","label":"InputPassword_label__kpx5-","labeldiv":"InputPassword_labeldiv__2VwwX","eye":"InputPassword_eye__zt1xv"};